import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

// AppRouter is imported from the API as a type-only import.
// The API package must be built (pnpm --filter @trinco/api build) before
// the dashboard can typecheck. Until then, the local commission calc falls
// back to its own logic without tRPC calls.
//
// To enable: uncomment the import below and remove the placeholder.
// import type { AppRouter } from '@trinco/api/trpc/router';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trpc = createTRPCReact<any>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RouterInputs = inferRouterInputs<any>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RouterOutputs = inferRouterOutputs<any>;
